import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_REPORT_VENDAS = [
  {
    module: 'REPORT_VENDAS',
    colunas: [
      {
        field: 'cupom.numero',
        active: true,
        removable: true
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'cliente.parceiro.cpf_cnpj',
        active: true,
        removable: false
      },
      {
        field: 'cliente.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      {
        field: 'cupom.vendedor.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      {
        field: 'valor_bruto',
        active: true,
        removable: true
      },
      {
        field: 'valor_desconto',
        active: true,
        removable: true
      },
      {
        field: 'valor_acrescimo',
        active: true,
        removable: true
      },
      {
        field: 'valor_total',
        active: true,
        removable: true
      },
      {
        field: 'cupom.status',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
